module.exports = __webpack_public_path__ + "img/sld_metering_panel_em_t1_b1.60dab483.svg";